
// src/config.js
export const BASE_URL = process.env.REACT_APP_BASE_URL || "http://127.0.0.1:8000";
// export const BASE_URL = "http://127.0.0.1:8000";
export const WS_URL_BASE = process.env.REACT_APP_WS_URL_BASE || "ws://127.0.0.1:8000/api/ws/location";
export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";

